// extracted by mini-css-extract-plugin
module.exports = {"imagePairWithText":"ImagePairWithText_imagePairWithText__Mds_g"};